import { nuovoDispositivoSchema, type NuovoDispositivoInput } from '@aulaviva/shared';
import { Alert, Button, OtpField, PageHeading } from '@aulaviva/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useNuovoDispositivo, useReinviaCodice } from '@/api/auth';
import { ErroreRichiesta } from '@/api/client';
import { auth } from '@/testi';

export function NuovoDispositivo() {
  const t = auth.nuovoDispositivo;
  const [params] = useSearchParams();
  const email = params.get('email') ?? '';
  const navigate = useNavigate();
  const conferma = useNuovoDispositivo();
  const reinvia = useReinviaCodice();
  const [errore, setErrore] = useState<string | null>(null);
  const [rinviato, setRinviato] = useState(false);
  const { control, register, handleSubmit, formState } = useForm<NuovoDispositivoInput>({
    resolver: zodResolver(nuovoDispositivoSchema),
    defaultValues: { email, codice: '' },
  });

  async function invia(dati: NuovoDispositivoInput) {
    setErrore(null);
    try {
      await conferma.mutateAsync(dati);
      navigate('/', { replace: true });
    } catch (e) {
      setErrore(e instanceof ErroreRichiesta && e.status === 400 ? auth.verificaEmail.codiceErrato : e instanceof Error ? e.message : auth.verificaEmail.codiceErrato);
    }
  }

  async function gestisciRinvia() {
    setRinviato(false);
    try {
      await reinvia.mutateAsync({ email, scopo: 'nuovo_dispositivo' });
      setRinviato(true);
    } catch (e) {
      setErrore(e instanceof Error ? e.message : auth.verificaEmail.codiceErrato);
    }
  }

  if (!email) {
    return (
      <>
        <PageHeading>{t.titolo}</PageHeading>
        <Alert variant="warning" title={auth.verificaEmail.emailMancante}>
          <Link to="/accedi">{t.tornaAllAccesso}</Link>
        </Alert>
      </>
    );
  }

  return (
    <>
      <PageHeading subtitle={t.sottotitolo(email)}>{t.titolo}</PageHeading>
      <form onSubmit={handleSubmit(invia)} noValidate className="flex flex-col gap-6">
        {rinviato && <Alert variant="success" title={t.rinviato} />}
        {errore && <Alert variant="error" title={errore} />}
        <input type="hidden" {...register('email')} />
        <Controller
          control={control}
          name="codice"
          render={({ field }) => (
            <OtpField label={auth.campi.codice} hint={auth.campi.aiutoCodice} value={field.value} onChange={field.onChange} onBlur={field.onBlur} error={formState.errors.codice?.message} />
          )}
        />
        <Button type="submit" variant="primary" size="lg" fullWidth loading={conferma.isPending} loadingText={t.inCorso}>
          {t.azione}
        </Button>
        <Button variant="discreet" onClick={gestisciRinvia} loading={reinvia.isPending} loadingText={t.inCorso} className="self-start">
          {t.rinvia}
        </Button>
      </form>
      <p className="t-body text-ink-muted">
        <Link to="/accedi">{t.tornaAllAccesso}</Link>
      </p>
    </>
  );
}
